import React, { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import HistoryIcon from "@mui/icons-material/History";
import PersonIcon from "@mui/icons-material/Person";
import SecurityIcon from "@mui/icons-material/Security";

import { BreadcrumbContext } from "../../Breadcrumb";
import DashboardShell from "../../DashboardShell";

const userSettingsNav = [
  {
    key: "profile",
    label: "Profile",
    description: "Identity and work profile",
    path: "/user/profile",
    paths: ["/user/profile"],
    icon: <PersonIcon fontSize="small" />,
  },
  {
    key: "security",
    label: "Security",
    description: "Password, MFA, and account controls",
    path: "/user/security",
    paths: ["/user/security", "/mfa/enroll", "/mfa/verify"],
    icon: <SecurityIcon fontSize="small" />,
  },
  {
    key: "activity",
    label: "Audit Logs",
    description: "Account event history",
    path: "/user/log",
    icon: <HistoryIcon fontSize="small" />,
  },
];

const resolveActiveKey = (pathname) => {
  const active = userSettingsNav.find((item) => (item.paths || [item.path]).includes(pathname));
  return active?.key || "profile";
};

const UserPageLayout = ({ title = "Account Settings", children }) => {
  const history = useHistory();
  const location = useLocation();
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const activeKey = resolveActiveKey(location.pathname);

  useEffect(() => {
    setBreadcrumb([
      { to: "/", text: "Home", active: false },
      { to: "/user/profile", text: "User", active: false },
      { to: null, text: title, active: true },
    ]);
  }, [setBreadcrumb, title]);

  const handleSelect = (key) => {
    const item = userSettingsNav.find((navItem) => navItem.key === key);
    if (item?.path && item.path !== location.pathname) {
      history.push(item.path);
    }
  };

  return (
    <DashboardShell
      title="User Settings"
      items={userSettingsNav}
      activeKey={activeKey}
      onSelect={handleSelect}
      compactHeader
      headerless
    >
      {children}
    </DashboardShell>
  );
};

export default UserPageLayout;
